import { toast } from "sonner"

export const showTeamManagementSuccessToast = (message: string) => {
  toast.success(message)
}

export const showTeamManagementErrorToast = (message: string) => {
  toast.error(message)
}
